import { render, staticRenderFns } from "./SimpleReport.vue?vue&type=template&id=74faea62"
import script from "./SimpleReport.vue?vue&type=script&lang=js"
export * from "./SimpleReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports